import { NO_BENCHMARK } from 'state/store/constants';
import { PortfolioItem } from '../types';

export const getPortfolioOptions = (portfolios: PortfolioItem[]): string[] => {
  const options: string[] = [NO_BENCHMARK];

  if (portfolios)
    portfolios.forEach((item) => {
      if (item.benchmarkName && !options.includes(item.benchmarkName)) {
        options.push(item.benchmarkName);
      }
    });

  return options;
};
